// removed by extract-text-webpack-plugin
module.exports = {"section":"c-Section__section","half":"c-Section__half","clear":"c-Section__clear"};